import styled from 'styled-components';

export const FormContainer = styled.div`
  .form-container {
    min-height: 300px;
    padding-bottom: 25px;
  }
`;
